import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const MyBooksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};

  h5 {
    color: ${tokens.colors.dark6};
    margin: ${tokens.spacing.verticalXxsmall} 0 ${tokens.spacing.verticalSmall};
  }

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.regular};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin-bottom: ${tokens.spacing.verticalLarge};
  }
`

export const WrittenBooksHistoryLink = styled.a`
  display: inline-block;
  width: fit-content;
  padding: 6px 16px;
  border: 1px solid ${tokens.colors.dark5};
  border-radius: ${tokens.radius.radius_10}px;
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${tokens.colors.dark5};
    color: ${tokens.colors.white};
  }
`
